import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from './shared.service';

@Injectable()
export class AuthGuardService {

	constructor(
		private sharedService: SharedService, 
		private router: Router
	) { }

	public userAccess = {
		"TA_ACCMANAGE_parent" : {
			"links": [
				"/dashboard",
				"/create/createAgency",
				"/create/modifyAgency",
				"/create/createAgent",
				"/create/modifyAgent",
				"/reports/balance",
				"/reports/commissions",
				"/reports/transaction",
				"/topUp"
			]
		},
		"TA_ACCMANAGE_child" : {
			"links": [
				"/dashboard",
				"/create/modifyAgency",
				"/create/createAgent",
				"/create/modifyAgent",
				"/topUp"
			]
		},
		"TA_ADMIN" : {
			"links": [
				"/reports/balance",
				"/reports/commissions",
				"/reports/transaction",
				"/topUp"
			]
		},
		"TRAVEL_AGENT" : {
			"links": [
				"/reports/balance",
				"/reports/commissions",
				"/reports/transaction",
				"/topUp"
			]
		}
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;
		console.log('Url:'+ url);
		if(url.indexOf("/externalRedirect") >= 0){
			this.sharedService.clearSession();
			return true;
		}

		if (this.sharedService.isUserLoggedIn()) {
			let loggedInUser = this.sharedService.getUserRole();
			if(this.userAccess[loggedInUser]) {
	        	if(this.userAccess[loggedInUser]['links'].includes(state.url)) {
	        		return true;
	        	}
	        }
		} else {
			console.log('Unauthorized to open link: '+ state.url);
    		//this.router.navigate([ this.sharedService.getLoginUrl() ]);
    		return false;
    	}
	}
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/auth-guard.service.ts